import React from "react";
import { Card, Empty, Icon, Tooltip, Tag, Spin } from "antd";


const { Meta } = Card;
type Props = {
    domainDescription: string | undefined;
    targetAudience: string | undefined;
    industryNiche: string | undefined;
    inProgress: boolean;
}


export default function DomainBusinessContext({ inProgress, domainDescription, targetAudience, industryNiche }: Props) {
    return (
        <Card
            className="domain-business-context"
            type="inner"
            title={
                <Meta
                    title={"Domain Business Context"}
                    description={"What LLMs knows about your domain's profile, target audience, and industry niche"}
                />
            }
            extra={inProgress ? <Tag color="orange">Analysis in progress <Spin indicator={<Icon type="loading-3-quarters" spin style={{ fontSize: "12px", marginLeft: "6px" }} />} /></Tag> : null}
        >
            {inProgress && (<Empty description="" />)}
            {!inProgress && !domainDescription && !targetAudience && !industryNiche && (<Empty description="No business context available" />)}

            {(!inProgress && domainDescription && targetAudience && industryNiche) && (
                <>
                    <div className="content-analysis-section">
                        <div className="section-title">
                            What is this domain about
                            <Tooltip title="We asked ChatGPT to describe what your domain is about, just like a user would. This shows how clearly your core topic is communicated.">
                                <Icon className="title-tooltip" type="question-circle" />
                            </Tooltip>
                        </div>
                        <div className="description-container">
                            <Icon className="orange" type="snippets" theme="twoTone" twoToneColor="#fe6100" />
                            <div className="description" dangerouslySetInnerHTML={{ __html: domainDescription }} />
                        </div>
                    </div>

                    <div className="content-analysis-section">
                        <div className="section-title">
                            Target audience
                            <Tooltip title="We asked ChatGPT to identify your domain's target audience. This helps you understand who your content is resonating with.">
                                <Icon className="title-tooltip" type="question-circle" />
                            </Tooltip>
                        </div>
                        <div className="description-container">
                            <Icon className="orange" type="idcard" theme="twoTone" twoToneColor="#fe6100" />
                            <div className="description" dangerouslySetInnerHTML={{ __html: targetAudience }} />
                        </div>
                    </div>

                    <div className="content-analysis-section">
                        <div className="section-title">
                            Industry niche
                            <Tooltip title="We asked ChatGPT to classify your domain's industry niche. This helps you see how well your content fits within its market.">
                                <Icon className="title-tooltip" type="question-circle" />
                            </Tooltip>
                        </div>
                        <div className="description-container">
                            <Icon className="orange" type="funnel-plot" theme="twoTone" twoToneColor="#fe6100" />
                            <div className="description" dangerouslySetInnerHTML={{ __html: industryNiche }} />
                        </div>
                    </div>
                </>
            )}
        </Card>
    );
}